import { Checkbox, Input, Select, TextArea } from "@/components/shared/form";
import { useTranslations } from "next-intl";
import TitleH5 from "../../fonts/TitleH5";

interface BasicFormDataProps {
  companyName: string;
  salutation: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  message: string;
}

const BasicFormData = ({ ...props }: BasicFormDataProps) => {
  const t = useTranslations("common");

  return (
    <div className="flex flex-col gap-2">
      <TitleH5 title={t("billData")} />
      <div className="flex flex-col gap-3">
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Input name={props.companyName} label={t("company")} />
          <Select
            name={props.salutation}
            label={`${t("salutation")}*`}
            placeholder={t("pleaseSelect")}
            selectItem={
              [
                { label: t("mr"), value: "mr" },
                { label: t("mrs"), value: "mrs" },
                { label: t("divers"), value: "divers" },
                { label: t("noneSalutation"), value: "noneSalutation" },
              ] as const
            }
          />
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Input name={props.firstName} label={`${t("firstName")}*`} />
          <Input name={props.lastName} label={`${t("lastName")}*`} />
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Input name={props.email} label={`${t("email")}*`} />
          <Input name={props.phone} label={`${t("phone")}*`} />
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Input name={props.street} label={`${t("street")}*`} />
          <Input name={props.houseNumber} label={`${t("houseNum")}*`} />
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Input name={props.postalCode} label={`${t("zip")}*`} />
          <Input name={props.city} label={`${t("city")}*`} />
        </div>
        <TextArea
          label={`${t("yourMessage")}...`}
          name={props.message}
          placeholder={`${t("yourMessage")}...`}
        />
        <Checkbox label={t("createAccount")} name="createAccount" />
      </div>
    </div>
  );
};

export default BasicFormData;
